// libraries
import styled from 'styled-components';

export const StyledFooterPenIcon = styled.svg`
  .icon-bg {
    transition: all 0.3s ease;
    fill: transparent;
    transform-origin: center;
    transform: scale(0.95);
  }

  .icon-path {
    transform-origin: center;
  }

  &:hover {
    .icon-bg {
      fill: #e3e5eb;
      transform: scale(1);
    }
  }

  &:active {
    .icon-bg {
      fill: #c1c4ce;
    }
  }
`;
